import moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { DateConverterService } from '@shared/services/date-converter/date-converter.service';
import { ApiServiceService } from '@shared/services/api-service/api-service.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AdviceMessageComponent } from '../advice-message/advice-message.component';
import { PickerDataSimpleComponent } from '../picker-data-simple/picker-data-simple.component';
import { FieldTypeDateComponent } from '../field-type-date/field-type-date.component';
import { InputNumberComponent } from '../input-number/input-number.component';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { FieldTypeListSimpleComponent } from '../field-type-list/field-type-list-simple/field-type-list-simple.component';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { ButtonWithTextMenuArrowComponent } from "../button-with-text-menu-arrow/button-with-text-menu-arrow.component";

@Component({
  selector: 'establish-pattern-modal',
  templateUrl: './establish-pattern-modal.component.html',
  standalone: true,
  imports: [AfTranslateDirective,
    FieldTypeListSimpleComponent,
    NgClass,
    FormsModule,
    InputNumberComponent,
    FieldTypeDateComponent,
    PickerDataSimpleComponent,
    AdviceMessageComponent,
    ButtonWithTextMenuArrowComponent
  ]
})
export class EstablishPatternModalComponent implements OnInit {
  item:any = this.dialogConfig.data.item;
  patternList:any = this.dialogConfig.data.patternList;
  date:any = this.dialogConfig.data.date;
  establishPatternModal:any = {
    radioOptionDaily: '1',
    radioOptionWeekly: '1',
    radioOptionMonthly: '1',
    radioOptionAnnual: '1',
    amountRepetitionsInterval: 10,
    periocityTypePredefined:'daily',
    finishIntervalDate: null,
    selectInterval: 'no-end-date',
    periodicityType: {
      label: this.translate.instant('repeat-pattern.frecuency'),
      required: true
    },
    repeatIntervalDate: {
      label: this.translate.instant('repeat-pattern.start-interval'),
      noEditable: true,
    },
    periodicityTypeSelected:{ listValueId: 0 },
    buttonMonthlyNumeral: { keyName: 'text', maxWidth: '155px', type: 'light' },
    buttonMonthlyWeekday:{ keyName: 'text', maxWidth: '174px', type: 'light' },
    buttonAnnualMonth: { keyName: 'text', maxWidth: '155px', type: 'light', orderBy: 'id' },
    buttonAnnualWeekday: { keyName: 'text', maxWidth: '155px', type: 'light'},
    finishIntervalItem: { type: 'light'},
  }
  constructor(
    private translate: AfTranslateFactory,
    private dateConverterService: DateConverterService,
    private commonUtilsService: CommonUtilsService,
    private apiService: ApiServiceService,
    private modalService: ModalServiceService,
    private dialogRef: DynamicDialogRef<EstablishPatternModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
    let that: any = this.establishPatternModal;
    that.repeatPattern = this.item.repeatPattern;
    that.patternList = this.patternList;

    if(that.repeatPattern?.frecuencyId){
      that.startInterval = new Date();
      that.infoText = this.translate.instant('repeat-pattern.modify-info');
      that.modifyPattern = true;
      this.configurePattern();
      this.extractInterval();
    }else{
      if(this.date && this.date !== null){
        that.startInterval = this.dateConverterService.toDate(this.date);
        that.infoText = this.translate.instant('repeat-pattern.communication-modify-info');
      }else{
        that.startInterval = new Date();
      }
      this.selectFrecuency(1);
    }
  }

  configurePattern(){
    let that: any = this.establishPatternModal;
    let repeatPattern: any = that.repeatPattern;
    this.selectFrecuency(repeatPattern.frecuencyId);
    switch(repeatPattern.frecuencyId){
      case 1:
        that.radioOptionDaily = repeatPattern.repeatOption.toString();
        if(repeatPattern.repeatOption === 1){
          that.dailyEachDay = repeatPattern.repeatParam1;
        }
        break;
      case 2:
        that.radioOptionWeekly = repeatPattern.repeatOption.toString();
        that.weeklyEachWeek = repeatPattern.repeatParam1;
        this.extractWeekDays()
        break;
      case 3:
        that.radioOptionMonthly = repeatPattern.repeatOption.toString();
        if(repeatPattern.repeatOption === 1){
          that.monthlyEachDay = repeatPattern.repeatParam1;
          that.monthlyEachMonth = repeatPattern.repeatParam2;
        }else{
          that.monthlyNumeralSelected = this.commonUtilsService.extractToArray(repeatPattern.repeatParam1, that.patternList.numeralTimeList, 'id');
          that.monthlyWeekdaySelected = this.commonUtilsService.extractToArray(repeatPattern.repeatParam2, that.patternList.weekDayList, 'id');
          that.monthlyEachMonthSecond = repeatPattern.repeatParam3;
        }
        break;
      default:
        that.radioOptionAnnual = repeatPattern.repeatOption.toString();
        if(repeatPattern.repeatOption === 1){
          that.annualEachDay = repeatPattern.repeatParam1;
          that.annualMonthSelected = this.commonUtilsService.extractToArray(repeatPattern.repeatParam2, that.patternList.monthList, 'id');
        }else{
          that.annualNumeralSelected = this.commonUtilsService.extractToArray(repeatPattern.repeatParam1, that.patternList.numeralTimeList, 'id');;
          that.annualWeekdaySelected =  this.commonUtilsService.extractToArray(repeatPattern.repeatParam2, that.patternList.weekDayList, 'id');
          that.annualMonthSelectedSecond = this.commonUtilsService.extractToArray(repeatPattern.repeatParam3, that.patternList.monthList, 'id');
        }
        break;
    }
  }

  extractInterval(){
    let that: any = this.establishPatternModal;
    that.selectInterval = 'no-end-date';
    if( that.repeatPattern.repeatTimes !== null){
      that.amountRepetitionsInterval = that.repeatPattern.repeatTimes;
      that.selectInterval = 'finish-after';
    }else if(that.repeatPattern.repeatUntil !== null){
      that.selectInterval = 'end-interval-day';
      that.finishIntervalDate = that.repeatPattern.repeatUntil;
    }
  }

  extractWeekDays(){
    this.establishPatternModal.weekDaysSelected = this.establishPatternModal.repeatPattern.repeatParam2;
    this.patternList.weekDays.forEach((weekdays:any)=>{
      if(weekdays.bit && this.establishPatternModal.weekDaysSelected === weekdays.bit){
        weekdays.selected = true;
      }
    })
  }

  selectFrecuency(index:number){
    this.establishPatternModal.periodicityTypeSelected = this.establishPatternModal.patternList.periodicityList[index - 1];
    if(this.establishPatternModal.periodicityTypeSelected?.listValueId === 3){
      this.establishPatternModal.monthlyNumeralSelected = this.establishPatternModal.monthlyNumeralSelected ? this.establishPatternModal.monthlyNumeralSelected : this.establishPatternModal.patternList.numeralTimeList[0];
      this.establishPatternModal.monthlyWeekdaySelected = this.establishPatternModal.monthlyWeekdaySelected ? this.establishPatternModal.monthlyWeekdaySelected : this.establishPatternModal.patternList.weekDayList[0];
    }else if(this.establishPatternModal.periodicityTypeSelected?.listValueId === 4){
      this.establishPatternModal.annualMonthSelected = this.establishPatternModal.annualMonthSelected ? this.establishPatternModal.annualMonthSelected : this.establishPatternModal.patternList.monthList[0];
      this.establishPatternModal.annualNumeralSelected = this.establishPatternModal.annualNumeralSelected ? this.establishPatternModal.annualNumeralSelected : this.establishPatternModal.patternList.numeralTimeList[0];
      this.establishPatternModal.annualWeekdaySelected = this.establishPatternModal.annualWeekdaySelected ? this.establishPatternModal.annualWeekdaySelected : this.establishPatternModal.patternList.weekDayList[0];
      this.establishPatternModal.annualMonthSelectedSecond = this.establishPatternModal.annualMonthSelectedSecond ? this.establishPatternModal.annualMonthSelectedSecond : this.establishPatternModal.patternList.monthList[0];
    }
  }

  setNumber(type:string, e:any){
    this.establishPatternModal[type] = e.newValue;
  }

  selectOptionSelectSimple(type:string, e:any){
    this.establishPatternModal[type] = e.option;
  }

  selectOption(type:string, e:any){
    this.establishPatternModal[type] = e.newValue;
  }

  addOrDeleteWeekDay(dayWeek:any){
    this.establishPatternModal.weekDaysSelected = 0;
      dayWeek.selected = !dayWeek.selected;
      this.establishPatternModal.patternList.weekDays.forEach((weekDay:any) => {
        if(weekDay.selected){
          this.establishPatternModal.weekDaysSelected += weekDay.bit
        }
      });
  }

  selectIntervalDate(e:any, type:string){
    this.establishPatternModal[type] = e.date;
    delete this.establishPatternModal.selectIntervalError;
  }

  changeInterval(){
    if(!(this.establishPatternModal.selectInterval === 'end-interval-day' && !this.establishPatternModal.finishIntervalDate)){
      delete this.establishPatternModal.selectIntervalError;
    }
  }

  validateRepetition(){
    let that: any = this.establishPatternModal;
    that.periodicityType.error = false;
    that.repeatIntervalDate.error = false;
    that.periodicityType.error = false;
    that.hasError = false;
    if(!that.periodicityTypeSelected){
      that.hasError = true;
      that.periodicityType.error = true;
    }else if(that.periodicityTypeSelected.listValueId === 2 && !that.weekDaysSelected ){
      that.hasError = true;
    }else if(that.periodicityTypeSelected.listValueId === 3 && that.radioOptionMonthly === "2"){
      if(that.monthlyWeekdaySelected.id === 3 && that.monthlyNumeralSelected.id > 2 ){
        that.hasError = true;
      }
    }else if( that.periodicityTypeSelected.listValueId === 4 && that.radioOptionAnnual === "2" ){
      if( that.annualWeekdaySelected.id === 3 && that.annualNumeralSelected.id > 2){
        that.hasError = true;
      }
    }else if(that.periodicityTypeSelected.listValueId === 4 && that.radioOptionAnnual === "1"){
      if(that.annualEachDay > 29 && that.annualMonthSelected.id === 2 || that.annualEachDay > 30 && that.annualMonthSelected.id === 4 || that.annualEachDay > 30 && that.annualMonthSelected.id === 6 || that.annualEachDay > 30 && that.annualMonthSelected.id === 9 || that.annualEachDay > 30 && that.annualMonthSelected.id === 11){
        that.hasError = true;
      }
    }
    if(that.selectInterval === 'end-interval-day' && !that.finishIntervalDate){
      that.hasError = true;
      that.selectIntervalError = true;
    }
    if(!that.hasError){
      if(moment(moment(that.startInterval).format('YYYY-MM-DD')).isBefore(moment().format('YYYY-MM-DD'))){
        that.hasError = true;
        that.repeatIntervalDate.error = true;
      }else if(that.startInterval === null){
        that.hasError = true;
        that.repeatIntervalDate.error = true;
      }else if(moment(moment(that.startInterval).format('YYYY-MM-DD')).isAfter(moment(that.finishIntervalDate).format('YYYY-MM-DD'))){
        that.hasError = true;
      }
    }
    if(that.hasError){
      this.modalService.errorModal({ text: this.translate.instant('establish-pattern-modal.error-validation-modal') });
    }else{
      this.getNextRepeat();
    }
  }

  getNextRepeat(){
    let repeatPattern = this.generateRepeatPattern()
    this.apiService.add('repeatpattern/next-repeat', repeatPattern)
    .then((data:any)=>{
      if(moment(moment().format('YYYY-MM-DD')).isAfter(moment(data.nextRepeat).format('YYYY-MM-DD'))){
        this.establishPatternModal.hasError = true;
        this.modalService.errorModal({ text: this.translate.instant('establish-pattern-modal.error-validation-modal') });
      }else{
        this.checkRestOfErrors();
      }
    }, (errorData:any)=>{})
  }

  generateRepeatPattern(){
    let repetition = this.getRepetition();
    let pattern ={
      frecuencyId: this.establishPatternModal.periodicityTypeSelected.listValueId,
      repeatStart: this.establishPatternModal.startInterval,
      repeatOption:  repetition.repeatOption,
      repeatTimes: null,
      repeatUntil: null,
      repeatParam1: null,
      repeatParam2: null,
      repeatParam3: null
    }
    this.setMomentCreation(pattern, this.establishPatternModal.periodicityTypeSelected.listValueId, pattern.repeatOption, repetition.repeatParams)
    return pattern;
  }

  setMomentCreation(pattern:any, frecuency:any, repeatOption:any, params:any){
    switch(frecuency){
      case 1:
        if(repeatOption === 1){
          pattern.repeatParam1 = params.repeatParam1;
        }
        break;
      case 2:
        pattern.repeatParam1 = params.repeatParam1;
        pattern.repeatParam2 = params.repeatParam2;
        break;
      case 3:
        if(repeatOption === 1){
          pattern.repeatParam1 = params.repeatParam1;
          pattern.repeatParam2 = params.repeatParam2;
        }else{
          pattern.repeatParam1 = params.repeatParam1
          pattern.repeatParam2 = params.repeatParam2
          pattern.repeatParam3 = params.repeatParam3
        }
        break;
      default:
        if(repeatOption === 1){
          pattern.repeatParam1 = params.repeatParam1;
          pattern.repeatParam2 = params.repeatParam2;
        }else{
          pattern.repeatParam1 = params.repeatParam1
          pattern.repeatParam2 = params.repeatParam2
          pattern.repeatParam3 = params.repeatParam3
        }
        break;
    }
  }

  checkRestOfErrors(){
    let that:any = this.establishPatternModal
      if(that.periodicityTypeSelected.listValueId === 3 && that.radioOptionMonthly === "1" && parseInt(that.monthlyEachDay) > 28){
        this.modalService.infoModal({ text: this.translate.instant('task-form.advice-interval-info-first') + that.monthlyEachDay + this.translate.instant('task-form.advice-interval-info-second') })
          .subscribe((result:any)=>{
            if(result.result ==='ok'){
              this.handleAccept();
            }
          });
      }else{
        this.handleAccept();
      }
  }

  itemSelected(item:any, e:any){
    item = e.value;
  }

  getRepetition(){
    let that: any = this.establishPatternModal;
    switch(that.periodicityTypeSelected.listValueId){
      case 1:
        if(that.radioOptionDaily === "1"){
          return {
            repeatOption: 1,
            repeatParams: {
              repeatParam1: that.dailyEachDay
            }
          }
        }else{
          return {
            repeatOption: 2,
            repeatParams: null
          }
        }
      case 2:
        return {
          repeatOption: 1,
          repeatParams: {
            repeatParam1: that.weeklyEachWeek,
            repeatParam2: that.weekDaysSelected
          }
        }
      case 3:
        if(that.radioOptionMonthly === "1"){
          return  {
            repeatOption: 1,
            repeatParams: {
              repeatParam1: that.monthlyEachDay,
              repeatParam2: that.monthlyEachMonth
            }
          }
        }else{
          return  {
            repeatOption: 2,
            repeatParams: {
              repeatParam1: that.monthlyNumeralSelected.id,
              repeatParam2: that.monthlyWeekdaySelected.id,
              repeatParam3: that.monthlyEachMonth,
            }
          }
        }
      default:
        if(that.radioOptionAnnual === "1"){
          return  {
            repeatOption: 1,
            repeatParams: {
              repeatParam1: that.annualEachDay,
              repeatParam2: that.annualMonthSelected.id
            }
          }
        }else{
          return  {
            repeatOption: 2,
            repeatParams: {
              repeatParam1: that.annualNumeralSelected.id,
              repeatParam2: that.annualWeekdaySelected.id,
              repeatParam3: that.annualMonthSelectedSecond.id,
            }
          }
        }
    }
  }

  closeAdvice(type:string){
    this.establishPatternModal[type] = false;
  }

  handleAccept() {
    let that: any = this.establishPatternModal
    let interval = {
      startInterval: that.startInterval,
      finishIntervalDate: that.finishIntervalDate,
      selectInterval: that.selectInterval,
      repeatTimes: that.selectInterval === 'finish-after'? that.amountRepetitionsInterval: null
    }
    this.dialogRef.close({
      result: 'ok',
      frecuency: that.periodicityTypeSelected,
      repetition: this.getRepetition(),
      interval: interval
    })
  }

  handleDismiss(reason:any) {
    this.dialogRef.close({result: reason});
  }
}
